/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.list.modals.member.controllers', [])

.controller('MembershipListModalsMemberController', ['$scope', '$uibModalInstance', 'modalTitle', 'modalMessage', 'showRenew', function($scope, $uibModalInstance, modalTitle, modalMessage, showRenew) {

    $scope.membershipListModalsMember = {

      model: "",
      modalTitle: '',
      modalMessage: '',
      showRenew: false,

      init: function() {
        this.modalTitle = modalTitle;
        this.modalMessage = modalMessage;
        this.showRenew = showRenew;
      },

      renew: function() {
        $uibModalInstance.close('renew');
      },

      clear: function() {
        $uibModalInstance.close('clear');
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipListModalsMember.init();

}]);
